import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import React, { useState } from 'react';
import axios from 'axios';
import { FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import { EmailField } from '../utils/validation/auth/AuthValidators';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/login/LoginForm.module.css';
import ErrorMessage from '../elements/ErrorMessage';

var RequestTokenForm = function RequestTokenForm(props) {
  var email = props.email,
      setEmail = props.setEmail,
      changeStep = props.changeStep;

  var _useState = useState(false),
      isLoading = _useState[0],
      editIsLoading = _useState[1];

  var _useState2 = useState(false),
      hasError = _useState2[0],
      editHasError = _useState2[1]; //load validation rules for fields


  var ValidationRules = {
    email: EmailField
  }; //blur validation

  function validateFieldOnBlur(e) {
    var value = e.target.value;
    var id = e.target.id;
    var res = ValidationRules[id](value);
    ShowValidation(id, res);
  }

  var handlePasswordReset = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var validForm, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              validForm = FormValidator('forgotPasswordForm', ValidationRules);

              if (!validForm) {
                _context.next = 17;
                break;
              }

              editIsLoading(true);
              _context.prev = 4;
              editHasError(false);
              _context.next = 8;
              return axios({
                method: "post",
                url: process.env.NEXT_PUBLIC_API + "/api/forgot-password",
                data: {
                  email: email
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              });

            case 8:
              response = _context.sent;
              editIsLoading(false);

              if (response.data.status == true) {
                changeStep('token');
              } else {
                editHasError(response.data.error);
              }

              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](4);
              editIsLoading(false);
              editHasError("Ups, avem o problemă. Te rugăm să încerci mai târziu.");

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 13]]);
    }));

    return function handlePasswordReset(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var spinner = isLoading && __jsx(React.Fragment, null, __jsx(Spinner, {
    as: "span",
    animation: "grow",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  }), "Te rug\u0103m s\u0103 a\u0219tep\u021Bi...");

  var btnDisabled = isLoading && 'disabled';

  var resetPasswordBtn = __jsx(Button, {
    variant: "secondary",
    type: "submit",
    className: "col-12",
    disabled: btnDisabled
  }, spinner, !isLoading && 'Continuă');

  var errorMessage = hasError && __jsx("div", {
    className: "mb-3"
  }, __jsx(ErrorMessage, {
    title: "Eroare",
    message: hasError
  }));

  return __jsx(React.Fragment, null, hasError ? errorMessage : __jsx("p", {
    className: styles.wizzardTitle
  }, "Completeaza adresa de email cu care te-ai \xEEnregistrat pe Conso."), __jsx(Form, {
    id: "forgotPasswordForm",
    onSubmit: handlePasswordReset
  }, __jsx(Form.Group, {
    controlId: "email"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Email"), __jsx(Form.Control, {
    type: "text",
    name: "email",
    placeholder: "Adresa de email",
    onChange: setEmail,
    onBlur: validateFieldOnBlur,
    value: email
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), resetPasswordBtn));
};

export default RequestTokenForm;